import PageHero from '../components/PageHero'
import SEO from '../components/SEO'
import { localBusinessSchema } from '../config/schema'
import { brand } from '../data/site'

export default function PrivacyPolicy() {
  return (
    <>
      <SEO page="privacy" structuredData={localBusinessSchema} />
      <PageHero index="09" eyebrow="Legal" title="Privacy policy" description="How website inquiries and visitor information are handled." image="directory-banner.webp" />
      <section className="section">
        <article className="container policy-page">
          <p><strong>Effective date:</strong> 2026</p>
          <p>Diamond Suites Ocala values your privacy and uses reasonable safeguards to protect information submitted through this website.</p>

          <h2>Information we collect</h2>
          <p>We may collect your name, email address, phone number, business name, leasing inquiry details, and the content of messages submitted through website forms. Basic technical data such as browser type, device information, IP address, and site activity may also be collected by hosting or analytics services.</p>

          <h2>How information is used</h2>
          <p>Information may be used to answer inquiries, provide suite availability information, schedule tours, review leasing interest, improve website operation, and communicate service-related updates.</p>

          <h2>Cookies and analytics</h2>
          <p>The website may use cookies or privacy-conscious analytics to understand traffic and improve functionality. Browser settings can be used to limit or remove cookies.</p>

          <h2>Information sharing</h2>
          <p>Diamond Suites Ocala does not sell personal information. Information may be shared with service providers that support website hosting, email delivery, leasing operations, security, or technology support when reasonably necessary.</p>

          <h2>Data security</h2>
          <p>Reasonable administrative and technical safeguards are used, but no internet transmission or electronic storage system can be guaranteed completely secure.</p>

          <h2>Third-party websites</h2>
          <p>Links may lead to independent providers or other external websites. Diamond Suites Ocala is not responsible for the content or privacy practices of those sites.</p>

          <h2>Your choices</h2>
          <p>You may request access, correction, or deletion of information you submitted, subject to legal and operational retention requirements. You may also opt out of marketing communication.</p>

          <h2>Children’s privacy</h2>
          <p>This website is not intended for children under 13.</p>

          <h2>Changes to this policy</h2>
          <p>This policy may be updated periodically. The current version will remain posted on this page.</p>

          <h2>Contact</h2>
          <address>
            {brand.name}<br />
            {brand.addressLine1}<br />
            {brand.addressLine2}<br />
            Phone: <a href={brand.phoneHref}>{brand.phoneDisplay}</a><br />
            Email: <a href={`mailto:${brand.email}`}>{brand.email}</a>
          </address>
        </article>
      </section>
    </>
  )
}
